import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
  root: {
    backgroundSize: "cover",
    height: "460px",
    boxShadow: "0 0 2px 0 rgba(0,0,0,.12), 0 2px 4px 0 rgba(0,0,0,.14)",
    display: "flex",
    alignItems: "flex-end",
    backgroundPositionX: "center",
    ...shorthands.border("none"),
    ...shorthands.borderRadius("16px"),
    ...shorthands.textDecoration("none"),

    "@media (max-width: 953px)": {
      height: "350px",
    },
  },
});
